import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Menu, X, User, LogOut, Shield, LayoutDashboard, FileSearch } from "lucide-react";
import { useState } from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_elite-scout-mvp/artifacts/uw8m7f8v_Simple%20Sports%20Football%20%26%20Soccer%20Badge%20Logo.png";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0A]/95 backdrop-blur-md border-b border-[#262626]" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2.5" data-testid="nav-logo">
            <img src={LOGO_URL} alt="Elite Scouting Network" className="h-10 w-10 rounded-full" />
            <span className="text-[#F5F5F5] font-bold text-base tracking-tight hidden sm:inline" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
              ELITE SCOUTING NETWORK
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/get-profile" className="text-[#A3A3A3] hover:text-[#F5F5F5] text-sm font-medium tracking-wide transition-colors" data-testid="nav-profile-page">
              GET PROFILE
            </Link>
            <Link to="/directory" className="text-[#A3A3A3] hover:text-[#F5F5F5] text-sm font-medium tracking-wide transition-colors" data-testid="nav-directory">
              DIRECTORY
            </Link>
            <Link to="/pricing" className="text-[#A3A3A3] hover:text-[#F5F5F5] text-sm font-medium tracking-wide transition-colors" data-testid="nav-pricing">
              PLANS
            </Link>
            {user && user !== false ? (
              <>
                <Link to="/dashboard" className="text-[#A3A3A3] hover:text-[#F5F5F5] text-sm font-medium tracking-wide transition-colors flex items-center gap-1.5" data-testid="nav-dashboard">
                  <LayoutDashboard size={14} strokeWidth={1.5} />
                  DASHBOARD
                </Link>
                {user.role === "admin" && (
                  <Link to="/admin" className="text-[#D4AF37] hover:text-[#C5A059] text-sm font-medium tracking-wide transition-colors flex items-center gap-1.5" data-testid="nav-admin">
                    <Shield size={14} strokeWidth={1.5} />
                    ADMIN
                  </Link>
                )}
                {user.role === "scout" && (
                  <Link to="/scout" className="text-[#D4AF37] hover:text-[#C5A059] text-sm font-medium tracking-wide transition-colors flex items-center gap-1.5" data-testid="nav-scout">
                    <FileSearch size={14} strokeWidth={1.5} />
                    SCOUT
                  </Link>
                )}
                <div className="flex items-center gap-3 pl-4 border-l border-[#262626]">
                  <span className="text-[#A3A3A3] text-sm">{user.name || user.email}</span>
                  <button onClick={handleLogout} className="text-[#A3A3A3] hover:text-[#F5F5F5] transition-colors" data-testid="nav-logout">
                    <LogOut size={16} strokeWidth={1.5} />
                  </button>
                </div>
              </>
            ) : (
              <div className="flex items-center gap-5">
                <Link to="/login" className="text-[#A3A3A3] hover:text-[#F5F5F5] text-sm font-medium tracking-wide transition-colors" data-testid="nav-signin">
                  SIGN IN
                </Link>
                <Link to="/start" className="btn-gold text-sm px-4 py-2" data-testid="nav-login">
                  CREATE PROFILE
                </Link>
              </div>
            )}
          </div>

          <button className="md:hidden text-[#F5F5F5]" onClick={() => setMobileOpen(!mobileOpen)} data-testid="nav-mobile-toggle">
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-[#0A0A0A] border-t border-[#262626] px-4 py-4 space-y-3">
          <Link to="/get-profile" onClick={() => setMobileOpen(false)} className="block text-[#A3A3A3] hover:text-[#F5F5F5] text-sm font-medium tracking-wide py-2">GET PROFILE</Link>
          <Link to="/directory" onClick={() => setMobileOpen(false)} className="block text-[#A3A3A3] hover:text-[#F5F5F5] text-sm font-medium tracking-wide py-2">DIRECTORY</Link>
          <Link to="/pricing" onClick={() => setMobileOpen(false)} className="block text-[#A3A3A3] hover:text-[#F5F5F5] text-sm font-medium tracking-wide py-2">PLANS</Link>
          {user && user !== false ? (
            <>
              <Link to="/dashboard" onClick={() => setMobileOpen(false)} className="block text-[#A3A3A3] hover:text-[#F5F5F5] text-sm font-medium tracking-wide py-2">DASHBOARD</Link>
              {user.role === "admin" && (
                <Link to="/admin" onClick={() => setMobileOpen(false)} className="block text-[#D4AF37] text-sm font-medium tracking-wide py-2">ADMIN</Link>
              )}
              <button onClick={() => { handleLogout(); setMobileOpen(false); }} className="block text-[#A3A3A3] text-sm font-medium tracking-wide py-2">LOGOUT</button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setMobileOpen(false)} className="block text-[#A3A3A3] hover:text-[#F5F5F5] text-sm font-medium tracking-wide py-2" data-testid="nav-mobile-signin">SIGN IN</Link>
              <Link to="/start" onClick={() => setMobileOpen(false)} className="block btn-gold text-sm text-center py-2">CREATE PROFILE</Link>
            </>
          )}
        </div>
      )}
    </nav>
  );
}
